/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/subscription.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { BillingPlatform } from "./common_enums";
import { ProductAddOn } from "./product_add_on";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Subscription
 */
export interface Subscription {
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp activated_at = 1;
     */
    activated_at?: Timestamp;
    /**
     * @generated from protobuf field: repeated fubo.tv.proto.common.v3.generic.ProductAddOn product_add_ons = 2;
     */
    product_add_ons: ProductAddOn[];
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.BillingPlatform billing_platform = 3;
     */
    billing_platform?: BillingPlatform;
    /**
     * @generated from protobuf field: optional string collection_method = 4;
     */
    collection_method?: string;
    /**
     * @generated from protobuf field: optional string currency = 5;
     */
    currency?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp current_period_ends_at = 6;
     */
    current_period_ends_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp current_period_started_at = 7;
     */
    current_period_started_at?: Timestamp;
    /**
     * @generated from protobuf field: optional int32 billing_cycle_len = 9;
     */
    billing_cycle_len?: number;
    /**
     * @generated from protobuf field: optional string billing_cycle_unit = 10;
     */
    billing_cycle_unit?: string;
    /**
     * @generated from protobuf field: repeated string product_codes = 11;
     */
    product_codes: string[];
    /**
     * @generated from protobuf field: optional string rate_plan_code = 12;
     */
    rate_plan_code?: string;
    /**
     * @generated from protobuf field: optional string rate_plan_name = 13;
     */
    rate_plan_name?: string;
    /**
     * @generated from protobuf field: optional string state = 14;
     */
    state?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp trial_ends_at = 15;
     */
    trial_ends_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp trial_started_at = 16;
     */
    trial_started_at?: Timestamp;
    /**
     * @generated from protobuf field: optional int32 unit_amount_in_cents = 17;
     */
    unit_amount_in_cents?: number;
    /**
     * @generated from protobuf field: optional string external_id = 18;
     */
    external_id?: string;
    /**
     * @generated from protobuf field: optional string product_type = 19;
     */
    product_type?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp canceled_at = 20;
     */
    canceled_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp expires_at = 21;
     */
    expires_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp paused_at = 22;
     */
    paused_at?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp resume_at = 23;
     */
    resume_at?: Timestamp;
    /**
     * @generated from protobuf field: optional int32 total_pause_cycles = 24;
     */
    total_pause_cycles?: number;
    /**
     * @generated from protobuf field: optional string generated_offer_code = 25;
     */
    generated_offer_code?: string;
    /**
     * @generated from protobuf field: optional string product_base = 26;
     */
    product_base?: string;
    /**
     * @generated from protobuf field: optional string billing_zip_code = 27;
     */
    billing_zip_code?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Subscription$Type extends MessageType<Subscription> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Subscription", [
            { no: 1, name: "activated_at", kind: "message", localName: "activated_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of activating account in RFC 3339 format." } },
            { no: 2, name: "product_add_ons", kind: "message", localName: "product_add_ons", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProductAddOn, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA.", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "defined only for base subscription event. If the event is for add ons then this should be empty" } },
            { no: 3, name: "billing_platform", kind: "enum", localName: "billing_platform", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.BillingPlatform", BillingPlatform], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "apple", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Payment platform used to subscribe." } },
            { no: 4, name: "collection_method", kind: "scalar", localName: "collection_method", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "automatic", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "payment collection method." } },
            { no: 5, name: "currency", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "USD", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Currency type: USD, EUR, CAD, etc." } },
            { no: 6, name: "current_period_ends_at", kind: "message", localName: "current_period_ends_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "End time of the subscription in RFC 3339 format." } },
            { no: 7, name: "current_period_started_at", kind: "message", localName: "current_period_started_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Start time of the subscription in RFC 3339 format." } },
            { no: 9, name: "billing_cycle_len", kind: "scalar", localName: "billing_cycle_len", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Billing cycle length." } },
            { no: 10, name: "billing_cycle_unit", kind: "scalar", localName: "billing_cycle_unit", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Billing cycle unit." } },
            { no: 11, name: "product_codes", kind: "scalar", localName: "product_codes", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "advanced-dvr-1000, unlimited-screen-home", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "list of products user has access to, including add-ons." } },
            { no: 12, name: "rate_plan_code", kind: "scalar", localName: "rate_plan_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ultimate-web-monthly", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "rate plan of the product." } },
            { no: 13, name: "rate_plan_name", kind: "scalar", localName: "rate_plan_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Ultimate Monthly", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "name of the rate plan." } },
            { no: 14, name: "state", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "active", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "current subscription state: active,canceled,paused,pause_scheduled,expired." } },
            { no: 15, name: "trial_ends_at", kind: "message", localName: "trial_ends_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of base trial ends in RFC 3339 format." } },
            { no: 16, name: "trial_started_at", kind: "message", localName: "trial_started_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of base trial starts in RFC 3339 format." } },
            { no: 17, name: "unit_amount_in_cents", kind: "scalar", localName: "unit_amount_in_cents", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "NA." } },
            { no: 18, name: "external_id", kind: "scalar", localName: "external_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Recurly subscription uuid." } },
            { no: 19, name: "product_type", kind: "scalar", localName: "product_type", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "base", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Product type, base or addon." } },
            { no: 20, name: "canceled_at", kind: "message", localName: "canceled_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of canceling in RFC 3339 format." } },
            { no: 21, name: "expires_at", kind: "message", localName: "expires_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of expiring in RFC 3339 format." } },
            { no: 22, name: "paused_at", kind: "message", localName: "paused_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Pause subscription time of the account in RFC 3339 format." } },
            { no: 23, name: "resume_at", kind: "message", localName: "resume_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Resume subscription time of the account in RFC 3339 format." } },
            { no: 24, name: "total_pause_cycles", kind: "scalar", localName: "total_pause_cycles", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Number of paused billing cycles i.e length of subscription." } },
            { no: 25, name: "generated_offer_code", kind: "scalar", localName: "generated_offer_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "KDA6RLD656P9E53WE", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Offer Code." } },
            { no: 26, name: "product_base", kind: "scalar", localName: "product_base", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Base product user has access to for this event." } },
            { no: 27, name: "billing_zip_code", kind: "scalar", localName: "billing_zip_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "10019", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Account billing zip code." } }
        ]);
    }
    create(value?: PartialMessage<Subscription>): Subscription {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.product_add_ons = [];
        message.product_codes = [];
        if (value !== undefined)
            reflectionMergePartial<Subscription>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Subscription): Subscription {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional google.protobuf.Timestamp activated_at */ 1:
                    message.activated_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.activated_at);
                    break;
                case /* repeated fubo.tv.proto.common.v3.generic.ProductAddOn product_add_ons */ 2:
                    message.product_add_ons.push(ProductAddOn.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.BillingPlatform billing_platform */ 3:
                    message.billing_platform = reader.int32();
                    break;
                case /* optional string collection_method */ 4:
                    message.collection_method = reader.string();
                    break;
                case /* optional string currency */ 5:
                    message.currency = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp current_period_ends_at */ 6:
                    message.current_period_ends_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.current_period_ends_at);
                    break;
                case /* optional google.protobuf.Timestamp current_period_started_at */ 7:
                    message.current_period_started_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.current_period_started_at);
                    break;
                case /* optional int32 billing_cycle_len */ 9:
                    message.billing_cycle_len = reader.int32();
                    break;
                case /* optional string billing_cycle_unit */ 10:
                    message.billing_cycle_unit = reader.string();
                    break;
                case /* repeated string product_codes */ 11:
                    message.product_codes.push(reader.string());
                    break;
                case /* optional string rate_plan_code */ 12:
                    message.rate_plan_code = reader.string();
                    break;
                case /* optional string rate_plan_name */ 13:
                    message.rate_plan_name = reader.string();
                    break;
                case /* optional string state */ 14:
                    message.state = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp trial_ends_at */ 15:
                    message.trial_ends_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.trial_ends_at);
                    break;
                case /* optional google.protobuf.Timestamp trial_started_at */ 16:
                    message.trial_started_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.trial_started_at);
                    break;
                case /* optional int32 unit_amount_in_cents */ 17:
                    message.unit_amount_in_cents = reader.int32();
                    break;
                case /* optional string external_id */ 18:
                    message.external_id = reader.string();
                    break;
                case /* optional string product_type */ 19:
                    message.product_type = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp canceled_at */ 20:
                    message.canceled_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.canceled_at);
                    break;
                case /* optional google.protobuf.Timestamp expires_at */ 21:
                    message.expires_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expires_at);
                    break;
                case /* optional google.protobuf.Timestamp paused_at */ 22:
                    message.paused_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.paused_at);
                    break;
                case /* optional google.protobuf.Timestamp resume_at */ 23:
                    message.resume_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.resume_at);
                    break;
                case /* optional int32 total_pause_cycles */ 24:
                    message.total_pause_cycles = reader.int32();
                    break;
                case /* optional string generated_offer_code */ 25:
                    message.generated_offer_code = reader.string();
                    break;
                case /* optional string product_base */ 26:
                    message.product_base = reader.string();
                    break;
                case /* optional string billing_zip_code */ 27:
                    message.billing_zip_code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Subscription, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional google.protobuf.Timestamp activated_at = 1; */
        if (message.activated_at)
            Timestamp.internalBinaryWrite(message.activated_at, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated fubo.tv.proto.common.v3.generic.ProductAddOn product_add_ons = 2; */
        for (let i = 0; i < message.product_add_ons.length; i++)
            ProductAddOn.internalBinaryWrite(message.product_add_ons[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.BillingPlatform billing_platform = 3; */
        if (message.billing_platform !== undefined)
            writer.tag(3, WireType.Varint).int32(message.billing_platform);
        /* optional string collection_method = 4; */
        if (message.collection_method !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.collection_method);
        /* optional string currency = 5; */
        if (message.currency !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.currency);
        /* optional google.protobuf.Timestamp current_period_ends_at = 6; */
        if (message.current_period_ends_at)
            Timestamp.internalBinaryWrite(message.current_period_ends_at, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp current_period_started_at = 7; */
        if (message.current_period_started_at)
            Timestamp.internalBinaryWrite(message.current_period_started_at, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 billing_cycle_len = 9; */
        if (message.billing_cycle_len !== undefined)
            writer.tag(9, WireType.Varint).int32(message.billing_cycle_len);
        /* optional string billing_cycle_unit = 10; */
        if (message.billing_cycle_unit !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.billing_cycle_unit);
        /* repeated string product_codes = 11; */
        for (let i = 0; i < message.product_codes.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.product_codes[i]);
        /* optional string rate_plan_code = 12; */
        if (message.rate_plan_code !== undefined)
            writer.tag(12, WireType.LengthDelimited).string(message.rate_plan_code);
        /* optional string rate_plan_name = 13; */
        if (message.rate_plan_name !== undefined)
            writer.tag(13, WireType.LengthDelimited).string(message.rate_plan_name);
        /* optional string state = 14; */
        if (message.state !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.state);
        /* optional google.protobuf.Timestamp trial_ends_at = 15; */
        if (message.trial_ends_at)
            Timestamp.internalBinaryWrite(message.trial_ends_at, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp trial_started_at = 16; */
        if (message.trial_started_at)
            Timestamp.internalBinaryWrite(message.trial_started_at, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 unit_amount_in_cents = 17; */
        if (message.unit_amount_in_cents !== undefined)
            writer.tag(17, WireType.Varint).int32(message.unit_amount_in_cents);
        /* optional string external_id = 18; */
        if (message.external_id !== undefined)
            writer.tag(18, WireType.LengthDelimited).string(message.external_id);
        /* optional string product_type = 19; */
        if (message.product_type !== undefined)
            writer.tag(19, WireType.LengthDelimited).string(message.product_type);
        /* optional google.protobuf.Timestamp canceled_at = 20; */
        if (message.canceled_at)
            Timestamp.internalBinaryWrite(message.canceled_at, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp expires_at = 21; */
        if (message.expires_at)
            Timestamp.internalBinaryWrite(message.expires_at, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp paused_at = 22; */
        if (message.paused_at)
            Timestamp.internalBinaryWrite(message.paused_at, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* optional google.protobuf.Timestamp resume_at = 23; */
        if (message.resume_at)
            Timestamp.internalBinaryWrite(message.resume_at, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 total_pause_cycles = 24; */
        if (message.total_pause_cycles !== undefined)
            writer.tag(24, WireType.Varint).int32(message.total_pause_cycles);
        /* optional string generated_offer_code = 25; */
        if (message.generated_offer_code !== undefined)
            writer.tag(25, WireType.LengthDelimited).string(message.generated_offer_code);
        /* optional string product_base = 26; */
        if (message.product_base !== undefined)
            writer.tag(26, WireType.LengthDelimited).string(message.product_base);
        /* optional string billing_zip_code = 27; */
        if (message.billing_zip_code !== undefined)
            writer.tag(27, WireType.LengthDelimited).string(message.billing_zip_code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Subscription
 */
export const Subscription = new Subscription$Type();
